import { referenceInterface as referenceInterfaceRegistry } from '@ardoq/reference-interface';
// eslint-disable-next-line no-restricted-imports
import { referenceInterface } from './referenceInterface';

export const initializeReferenceInterface = () => {
  referenceInterfaceRegistry.registerImplementation({
    ...referenceInterface,
  });
};
